import { createContext, useContext } from 'react';

export const PropertyIdContext = createContext<string | undefined>(undefined);

export const usePropertyId = () => {
  const propertyId = useContext(PropertyIdContext);
  return propertyId ?? '';
};
